import React from 'react';

type Props = {
  id: string;
  name?: string;
  label?: string;
  classes?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  checked?: boolean;
  hasError?: boolean;
  noCheckbox?: boolean;
  disabled?: boolean;
  required?: boolean;
};

export const Checkbox = ({ id, name, label, onChange, checked, hasError, classes, noCheckbox, disabled, required }: Props) => {
  return (
    <div className={`field ${hasError ? 'has-error' : ''}`}>
      <label
        className='flex gap-x-2'
        htmlFor={id}
      >
        <input
          type='checkbox'
          id={id}
          name={name}
          checked={checked}
          onChange={onChange}
          className={`${noCheckbox ? '!hidden' : ''}`}
          disabled={disabled}
          required={required}
        />
        {label && <span className={`${classes}`}>{label}</span>}
      </label>
    </div>
  );
};
